export const messages = {
  en: {
    systemInfo: {
      title: 'System Configuration',
      editTitle: 'Edit System Configuration',
      systemTitle: 'System Title',
      subSystemTitle: 'Sub Title',
      systemSimpleTitle: 'Short Title',
      companyName: 'Company Name',
      logoUrl: 'Logo URL',
      imgUrl: 'Static URL',
      defaultCommunityId: 'Default Community ID',
      ownerTitle: 'Owner Title',
      propertyTitle: 'Property Title',
      qqMapKey: 'QQ Map Key',
      mallUrl: 'Mall URL',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      required: 'Required',
      updateSuccess: 'Update successful'
    }
  },
  zh: {
    systemInfo: {
      title: '系统配置',
      editTitle: '修改系统配置',
      systemTitle: '标题名称',
      subSystemTitle: '副标题',
      systemSimpleTitle: '简写标题',
      companyName: '公司名称',
      logoUrl: 'logo地址',
      imgUrl: '静态url',
      defaultCommunityId: '默认小区编号',
      ownerTitle: '业主标题',
      propertyTitle: '物业手机标题',
      qqMapKey: 'qq地图key',
      mallUrl: '商城地址',
      save: '保存',
      cancel: '取消',
      edit: '修改',
      required: '必填',
      updateSuccess: '修改成功'
    }
  }
}